import { render } from "./App.vue?vue&type=template&id=618df2fa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=618df2fa&lang=less"

import exportComponent from "F:\\ypx\\zhiniao\\zhiniao-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__